// @ts-nocheck

(() => {
    const selector = '[data-wardrobe-category-grid-2]';

    const initialize = (scope = document) => {
        scope.querySelectorAll(selector).forEach((section) => {
            if (section.dataset.initialized === 'true') return;

            section.dataset.initialized = 'true';

            requestAnimationFrame(() => {
                section.classList.add('is-ready');
            });
        });
    };

    initialize();

    document.addEventListener('shopify:section:load', (event) => {
        initialize(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('.wardrobe-category-grid-2__card');

        if (card) {
            card.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest'
            });
        }
    });
})();